import React from 'react';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import { getCurrency } from 'enums/currencyEnum';
import { IconButton, SelectReduxFormWrapper, Button, DatePickerInput, Layout } from '@hub-mono/ui';
import { useDispatch } from 'react-redux';
import { isAfter, isBefore } from '../../../../utils/DateUtil';
import { modalActions } from '@hub-mono/app-modules';

const InternalExternalResourceRates = ({ rates, type, name, onChange }) => {
    const dispatch = useDispatch();
    return (
        <div>
            <FieldArray
                name={name}
                component={({ fields }) => (
                    <React.Fragment>
                        {fields.map((rate, i) => {
                            let itemValues = fields.get(i);
                            return (
                                <Layout key={i} pb="--Spacing-100" gap="--Spacing-100">
                                    <Layout flex="0 0 40%">
                                        <Field
                                            inline
                                            name={`resourceRates.${type}.${i}.defaultRateId`}
                                            component={SelectReduxFormWrapper}
                                            filter
                                            label="Rate"
                                            placeholder="Search for Rate"
                                            optionValue="_id"
                                            optionLabel={item =>
                                                Object.keys(item).length
                                                    ? `${item.label}: ${getCurrency(item.currency).symbol} ${item.rate}`
                                                    : null
                                            }
                                            options={rates}
                                        />
                                    </Layout>
                                    <Layout flex="0 0 25%">
                                        <DatePickerInput
                                            clearable
                                            label="Rate Starts"
                                            value={
                                                itemValues.effectiveFrom
                                                    ? new Date(itemValues.effectiveFrom)
                                                    : undefined
                                            }
                                            onChange={date =>
                                                onChange({
                                                    [`${rate}.effectiveFrom`]: date,
                                                    [`${rate}.effectiveTo`]: itemValues.effectiveTo
                                                        ? new Date(itemValues.effectiveTo)
                                                        : undefined,
                                                })
                                            }
                                            disabledDays={date => {
                                                if (!itemValues.effectiveTo) {
                                                    return false;
                                                }
                                                return isAfter(date, itemValues.effectiveTo, 'day');
                                            }}
                                        />
                                    </Layout>
                                    <Layout flex="0 0 25%">
                                        <DatePickerInput
                                            clearable
                                            label="Rate Ends"
                                            value={
                                                itemValues.effectiveTo ? new Date(itemValues.effectiveTo) : undefined
                                            }
                                            onChange={date =>
                                                onChange({
                                                    [`${rate}.effectiveFrom`]: itemValues.effectiveFrom
                                                        ? new Date(itemValues.effectiveFrom)
                                                        : undefined,
                                                    [`${rate}.effectiveTo`]: date,
                                                })
                                            }
                                            disabledDays={date => {
                                                if (!itemValues.effectiveFrom) {
                                                    return false;
                                                }
                                                return isBefore(date, itemValues.effectiveFrom, 'day');
                                            }}
                                        />
                                    </Layout>
                                    <Layout flex="1 1 auto" hAlign="flex-end">
                                        <IconButton
                                            icon="delete"
                                            onClick={() => {
                                                dispatch(
                                                    modalActions.showDeleteConfirmationModal({
                                                        onConfirm: () => {
                                                            fields.remove(i);
                                                        },
                                                        title: 'Delete rate?',
                                                        message:
                                                            'You are about to delete a rate from the system. This cannot be undone. The rate will be removed from all reports. If you want to maintain it, please change the effective dates',
                                                        confirmText: 'Delete rate',
                                                    })
                                                );
                                            }}
                                        />
                                    </Layout>
                                </Layout>
                            );
                        })}
                        <Button variant="text" startIcon="navigateNext" onClick={() => fields.push({})}>
                            Add new {type} Rate
                        </Button>
                    </React.Fragment>
                )}
            />
        </div>
    );
};

InternalExternalResourceRates.propTypes = {
    name: PropTypes.string.isRequired,
    rates: PropTypes.array,
    onChange: PropTypes.func,
    type: PropTypes.string,
};

InternalExternalResourceRates.defaultProps = {
    rates: [],
    onChange: null,
    type: 'external',
};

export default InternalExternalResourceRates;
